export default __webpack_public_path__ + "static/media/sideBar-bg.7fc1c1b1.webp";